export default async function retryAsync(fn, retries = 3, delay = 1000) {
    let attempt = 0;
    while (attempt < retries) {
        try {
            return await fn();
        } catch (error) {
            attempt++;
            const shouldRetry =
                error.message.includes("timeout") ||
                !error.response || // network errors
                (error.response.status >= 500 && error.response.status < 600);
            if (!shouldRetry || attempt >= retries) {
                throw error;
            }
            await new Promise((resolve) => setTimeout(resolve, delay));
        }
    }
}